import { FormText } from '@energybox/react-ui-library/dist/components';
import {
  defaultBinaryCounterParameters,
  ParametersBinaryCounter,
} from '@energybox/react-ui-library/dist/types';

import React from 'react';
import TextField from '../../../ui/TextField';
import StepConditionItem from './StepConditionItem';
import StepConditionItemInput from './StepConditionItemInput';

type Props = {
  onChange: (arg0: string, arg1: string) => void;
  parameters?: ParametersBinaryCounter;
};

const ConditionBinaryCounter = ({
  onChange,
  parameters = defaultBinaryCounterParameters,
}: Props) => (
  <StepConditionItem
    label={<FormText>Openings:</FormText>}
    condition={
      <StepConditionItemInput
        value={
          <TextField
            type="number"
            value={
              parameters.maxOpeningCount
                ? parameters.maxOpeningCount.toString()
                : '5'
            }
            onChange={ev => onChange('maxOpeningCount', ev.currentTarget.value)}
          />
        }
        unit={<FormText>Times</FormText>}
      />
    }
  />
);

export default ConditionBinaryCounter;
